import React, { useEffect, useMemo, useState, useRef } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { PAYMENT_CHANELS, PageName } from "../../../constants/common";
import { Image } from "semantic-ui-react";
import {
  fetchChanelAndMethod,
  fetchPromotionsOffer,
  setChannelAndMethod,
  fetchPaymentChannelData,
} from "../../checkout/actions";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  ChannelItemType,
  MethodItemType,
  ProfileInfoType,
  OfferItemType,
  DeviceType,
  StorageKEY,
} from "../../../models";
import { formatPrice, isEmpty, isValidHttpUrl } from "../../../utils/common";
import { checkoutApi } from "../../../api/checkout";
import { fetchEventSource } from "@microsoft/fetch-event-source";
import { useNavigate } from "react-router-dom";
import PaymentContainer from "./PaymentContainer";
import Modal from "../../../components/Modal";
import ModalContentPayment from "./ModalContentPayment";
import PaymentGuild from "./PaymentGuid";
import { logout } from "../../../reducer/user";
import { resetBooking } from "../../../reducer/booking";
import * as Icon from "react-feather";
import { tracker } from "../../../api/trackingService";
let hasCallHub = false;
const CheckOut: React.FC<{
  channelType: PageName | undefined;
  userData: ProfileInfoType;
  isLogedin: boolean;
  isPaymentProcess: boolean;
  isBooking?: boolean;

  onSubmitPayment: ({
    methodId,
    offer,
  }: {
    methodId: string;
    offer: OfferItemType;
  }) => void;
  sessionId: string;
  ipAddress: string;
}> = ({
  channelType,
  userData,
  isLogedin,
  isPaymentProcess,
  isBooking,
  onSubmitPayment,
  sessionId,
  ipAddress,
}) => {
  const dispatch = useAppDispatch();
  const { channel, method } = useAppSelector(
    (state) => state.checkout.chanelAndMethod
  );
  const navigate = useNavigate();
  const location = useLocation();
  const deviceInfo = useAppSelector((state) => state.chanel.deviceInfo);
  const bookingInfo = useAppSelector((state) => state.booking);

  const bookingChannelMethod = useAppSelector(
    (state) => state.booking.channelAndMethod
  );
  const trackingParams = useMemo(() => {
    let mktCampaign = "";
    let eventLabel = "";

    switch (channelType) {
      case PageName.VNPAY: {
        eventLabel = "PNS-TVOD-GPVNP50k";
        mktCampaign = "pns_landing_vnp_nbn";
        break;
      }
      case PageName.SHOPEE: {
        eventLabel = "PNS-TVOD-GPSPP50k";
        mktCampaign = "pns_landing_spp_nbn";
        break;
      }
      case PageName.ZALO: {
        eventLabel = "PNS-TVOD-GPZLP50k";
        mktCampaign = "pns_landing_zlp_nbn";
        break;
      }
    }
    return {
      on_screen: "payment",
      session_id: sessionId,
      user_id: userData?.id,
      client_ip: ipAddress,
      mkt_campaign: mktCampaign,
    };
  }, [ipAddress, sessionId, userData, channelType]);
  const [offeIsNotAvailable, setOfferIsNotAvailable] = useState(false);
  const controlRef = useRef<AbortController>();
  const [modal, setModal] = useState({
    isShowModal: false,
    title: "",
    type: {
      isPaymentFail: false,
      isTimeout: false,
      isPaymentSuccess: false,
      isStreammingFail: false,
      isPaymentError: false,
    },
  });

  const [counterStart, setCounterStart] = useState(new Date().getTime());
  const [isLoadingQr, setLoadingQr] = useState(true);

  const channelTypeName = useMemo(() => {
    let channelName = "";
    switch (channelType) {
      case PageName.SHOPEE: {
        channelName = PAYMENT_CHANELS.SHOPEEPAY;
        break;
      }
      case PageName.VNPAY: {
        channelName = PAYMENT_CHANELS["VNPAY-QR"];
        break;
      }
      case PageName.ZALO: {
        channelName = PAYMENT_CHANELS.ZALOPAY;
        break;
      }
    }
    return channelName;
  }, [channel, channelType]);

  const channelCampaign = useMemo(() => {
    return channel.find((item) => item.type === channelTypeName) || {};
  }, [channel, channelType]);

  const onSelectPaymentChannel = async ({
    chanelItem,
    offer,
  }: {
    chanelItem: ChannelItemType;
    offer: OfferItemType;
  }) => {
    let channelAndMethod: {
      channel: ChannelItemType;
      method: MethodItemType;
    } = { channel: chanelItem, method: {} };

    const currentMethod = method.find(
      (item) => item.channelId === chanelItem.id
    );

    let direactObjectId = "";
    switch (channelType) {
      case PageName.VNPAY: {
        direactObjectId = "vnpay";

        break;
      }
      case PageName.SHOPEE: {
        direactObjectId = "shopeepay";

        break;
      }
      case PageName.ZALO: {
        direactObjectId = "zalopay";
        break;
      }
    }

    const trackerData = {
      ...trackingParams,
      indirect_object_property: userData?.phone,
      direct_object_type: "method",
      indirect_object_id: "mobile",
      direct_object_id: direactObjectId,
    };
    tracker({
      ...trackerData,
    });

    setLoadingQr(true);
    if (currentMethod) {
      console.log("method is connected");
      channelAndMethod = {
        ...channelAndMethod,
        method: currentMethod,
      };

      dispatch(
        setChannelAndMethod({
          ...channelAndMethod,
        })
      );
    } else {
      dispatch(
        setChannelAndMethod({
          ...channelAndMethod,
        })
      );

      let paymentParams = {
        channelType: channelTypeName,
        clientId: userData.id || "",
        returnUrl: `${
          window.location.href
        }?productId=${offer.productId?.replace("#10", "")}`,
        offer: offer,
      };

      if (deviceInfo.partner === DeviceType.MOBILE) {
        paymentParams = {
          ...paymentParams,
          returnUrl: `${
            window.location.href
          }?productId=${offer.productId?.replace("#10", "")}`,
          offer: offer,
        };
      }

      const response = await dispatch(
        fetchPaymentChannelData({
          ...paymentParams,
        })
      ).unwrap();

      setLoadingQr(false);
      /**
       * listen event hub
       */
      if (response.error === 0 && deviceInfo.partner === DeviceType.PC && !hasCallHub) {
        hasCallHub = true;
        await onlistenHubPayment({
          channelType: channelTypeName,
          token: response.syncData.token || "",
          offer: offer,
          channel: chanelItem,
        });
      }
    }
  };
  /**
   * for QRScan payment
   */
  const onlistenHubPayment = async (args: {
    channelType: string;
    token: string;
    offer: OfferItemType;
    channel: ChannelItemType;
  }) => {
    const { channelType, token, offer, channel } = args;
    let inputUrl = "";
    switch (channelType) {
      case PAYMENT_CHANELS.ZALOPAY: {
        inputUrl = "zalopay";
        break;
      }
      case PAYMENT_CHANELS.SHOPEEPAY: {
        inputUrl = "shopeepay";
        break;
      }
      case PAYMENT_CHANELS["VNPAY-QR"]: {
        inputUrl = "vnpay";
        break;
      }
    }
    controlRef.current = new AbortController();
    await fetchEventSource(`${process.env.REACT_APP_API_HUB_URL}/${inputUrl}`, {
      method: "GET",
      headers: {
        accept: "text/event-stream",
        "access-token": token,
        "content-type": "text/event-stream",
      },
      signal: controlRef.current.signal,
      openWhenHidden: true,
      onopen: async (response) => {
        if (response.status === 200) {
          console.log("counting...");
          const dateCount = new Date().getTime() + 10 * 60 * 1000;
          setCounterStart(dateCount);
        }
      },
      onmessage: async (ev) => {
        // console.log(data);
        if (ev.data) {
          const parsedData = JSON.parse(ev.data);

          if (parsedData && parsedData.status === 1) {
            //fetch to get paymentmethod
            const response = await checkoutApi.fetchChanelAndMethod();

            if (response.error === 0) {
              const method = response.data.method?.find(
                (method) => method.channelId === channel.id
              );
              /**
               * SUBMIT PAYMENT
               */
              if (channelType === PAYMENT_CHANELS["VNPAY-QR"]) {
                await tracker({
                  ...trackingParams,
                  on_screen: "payment_result",
                  direct_object_type: "package",
                  indirect_object_property: "vnpay",
                  indirect_object_type: "result",
                  direct_object_property: offer?.productName,
                  direct_object_id: offer?.productId,
                  event_action: "buy",
                  context_value: {
                    price: offer?.price,
                  },
                  indirect_object_id: "success",
                });
                navigate(`/${channelType}/thankyou`);
              } else {
                onSubmitPayment({
                  methodId: method?.methodId || "",
                  offer: offer,
                });
              }
            }
          } else {
            console.log("sync payment fail", ev.data);
            await tracker({
              ...trackingParams,
              on_screen: "payment_result",
              direct_object_type: "package",
              indirect_object_property: "vnpay",
              indirect_object_type: "result",
              direct_object_property: offer?.productName,
              direct_object_id: offer?.productId,
              event_action: "buy",
              context_value: {
                price: offer?.price,
              },
              indirect_object_id: "failed",
            });
            setModal((prevModal) => ({
              ...prevModal,
              isShowModal: true,
              type: {
                ...prevModal.type,
                isPaymentError: true,
              },
            }));
          }
        }
      },
      onclose: async () => {
        console.log("closed");
      },
    });
  };

  const onExpiredPaymentQr = () => {
    controlRef.current?.abort();
    setModal((prevModal) => ({
      isShowModal: true,
      title: "Phiên giao dịch hết hạn",
      type: {
        ...prevModal.type,
        isTimeout: true,
      },
    }));
  };
  const onRetryPaymentQrcode = ({
    chanelItem,
    offer,
  }: {
    chanelItem: ChannelItemType;
    offer: OfferItemType;
  }) => {
    setModal({
      isShowModal: false,
      title: "",
      type: {
        isTimeout: false,
        isPaymentFail: false,
        isStreammingFail: false,
        isPaymentSuccess: false,
        isPaymentError: false,
      },
    });
    console.log({ offer });
    onSelectPaymentChannel({ chanelItem: chanelItem, offer });
  };
  const handlePaymentWebview = (deepLink: string) => {
    if (isValidHttpUrl(deepLink)) {
      window.location.href = deepLink;
    }
  };

  useEffect(() => {
    (async () => {
      await dispatch(fetchChanelAndMethod());
    })();
  }, []);
  useEffect(() => {
    if (isEmpty(channelCampaign)) return;
    (async () => {
      const promotionOffer = await dispatch(
        fetchPromotionsOffer({
          titleId: process.env.REACT_APP_TITLE_ID || "",
          channelType: channelType,
        })
      ).unwrap();
      const trackerData = {
        ...trackingParams,
        on_screen: "payment",
        direct_object_type: "screen",
        direct_object_id: "promotion_result",
        event_action: "view",
      };

      if (!isEmpty(promotionOffer)) {
        await tracker({
          ...trackerData,
          direct_object_property: "success",
        });

        await onSelectPaymentChannel({
          chanelItem: channelCampaign,
          offer: promotionOffer,
        });
      } else {
        setOfferIsNotAvailable(true);
        await tracker({
          ...trackerData,
          direct_object_property: "fail",
        });
      }
    })();
  }, [channelType, channel]);

  // useEffect(() => {
  //   const trackerData = {
  //     ...trackingParams,
  //     on_screen: "payment",
  //     indirect_object_property: userData?.phone,
  //     direct_object_type: "screen",
  //     indirect_object_id: "mobile",
  //     direct_object_id: "promotion_result",
  //     direct_object_property: "success",
  //   };

  //   tracker({
  //     ...trackerData,
  //   });
  // }, []);

  return (
    <>
      <div className="checkout-section">
        <div className="checkout-header">
          <Image
            src={`${process.env.PUBLIC_URL}/images/${channelType}/thongtinthanhtoan.png`}
          />
        </div>
        <div className="summary">
          <div className="summary-item">
            <span className="label">Tài khoản</span>
            <span className="value">{userData.phone}</span>
          </div>
          <div className="summary-item">
            <span className="label">Đơn giá</span>
            <span className="value">
              {formatPrice(bookingInfo?.offer?.totalPriceOffer || 0)}
            </span>
          </div>
        </div>
        <div className="payment">
          <div className="payment-method">
            <div className="icon-payment">
              <Image
                src={`${process.env.PUBLIC_URL}/images/${channelType}/logo-partner-second.png`}
                alt="logo"
              />
            </div>
            <div className="qrcode">
              <PaymentContainer
                counterStart={counterStart}
                offer={bookingInfo.offer}
                onTimeoutQrcode={onExpiredPaymentQr}
                paymentData={bookingInfo.paymentData}
                currentMethod={bookingChannelMethod.method}
                onSubmitPaymentWebview={handlePaymentWebview}
                onSubmitPayment={onSubmitPayment}
                channelType={channelType}
                isDesktop={deviceInfo.partner === DeviceType.PC}
                isLoading={isLoadingQr}
                isPaymentProcess={isPaymentProcess}
              />
            </div>
            {(deviceInfo.partner === DeviceType.PC && (
              <PaymentGuild channelType={channelType || ""} />
            )) || <></>}
          </div>
        </div>
      </div>
      <Modal
        isOpen={modal.isShowModal}
        width={550}
        isShowCloseIcon={false}
        title={modal.title}
        render={() => <ModalContentPayment type={modal.type} />}
        onSubmit={() => {
          if (modal.type.isPaymentFail || modal.type.isPaymentError) {
            dispatch(logout());
            dispatch(resetBooking());
          } else {
            onRetryPaymentQrcode({
              chanelItem: bookingChannelMethod.channel,
              offer: bookingInfo.offer,
            });
          }
        }}
      />
      <Modal
        isOpen={offeIsNotAvailable}
        width={550}
        isShowHeader={false}
        isShowCloseIcon={false}
        render={() => (
          <div className="fail-offer">
            <div className="icon fail">
              <Icon.X size={30} />
            </div>
            <p>Sự kiện diễn ra hiện không khả dụng.</p>
            <p>Quý khách vui lòng thử lại sau.</p>
          </div>
        )}
        onSubmit={() => {
          dispatch(logout());
          dispatch(resetBooking());
        }}
      />
    </>
  );
};
export default CheckOut;
